export const SKIP_INSTITUTION_SELECTOR = "skip_institution_selector";
